"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVendorActive = exports.listVendors = void 0;
const ApiClient_1 = require("../ApiClient");
const listVendors = () => ApiClient_1.apiClient.get('/api/vendors');
exports.listVendors = listVendors;
const setVendorActive = (key, isActive) => ApiClient_1.apiClient.put(`/api/vendors/${encodeURIComponent(key)}/active`, { isActive });
exports.setVendorActive = setVendorActive;
